import axios from 'axios';

const deleteTicketApi = async (token, id) => {
  // const formDate = new FormData();
  // for (let id of ids) {
  //   formDate.append('id[]', id);
  // }
  try {
    const res = await axios.post(
      `tickets/${id}/delete`,
      {},
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'applications/json',
          Authorization: 'Bearer ' + token,
          lang: 'ar'
        }
      }
    );

    return res;
  } catch (error) {
    throw error;
  }
};

export default deleteTicketApi;
